import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import QRCodeComponent from './QRCodeComponent';

export const QRCodeNode = Node.create({
    name: 'qrCode',
    group: 'inline', // or 'block' depending on your use case
    inline: true,
    atom: true, // treated as a single unit

    addAttributes() {
        return {
            url: {
                default: null,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'qr-code',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['qr-code', mergeAttributes(HTMLAttributes)];
    },

    addCommands() {
        return {
            insertQRCode:
                attrs =>
                ({ chain }) =>
                    chain()
                        .focus()
                        .setParagraph()
                        .insertContent({ type: this.name, attrs })
                        .run(),
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(QRCodeComponent);
    },
});
